export default __webpack_public_path__ + "35c11edde02b63432f0d9bc0e47f99e4.svg";